<template>
    <div>
        <a @click="toggleConfirmModal()" class="btn dropdown__submenu__btn">
            <slot name="button"></slot>
        </a>
        <Modal ref="deleteconfirmation" size="modal--mini">
            <div slot="content">

                <slot name="content"></slot>

                <form method="POST"
                           enctype="multipart/form-data"
                           :action="this.route">
                    <input type="hidden" name="_method" value="DELETE">

                    <slot name="input-form"></slot>

                    <button type="submit" class="btn-cta mr10"><slot name="button"></slot></button>
                    <button class="link" @click="toggleConfirmModal()"><slot name="cancel"></slot></button>
                </form>
            </div>
        </Modal>
    </div>
</template>

<script>

    import Modal from '../layout/Modal.vue';

    export default {
        props: {
            route: String
        },
        data: function () {
            return {}
        },
        components: {
            'Modal': Modal
        },
        methods: {
            toggleConfirmModal: function() {
                if (!this.$refs.deleteconfirmation.isOpen) {
                    this.$root.$el.appendChild(this.$refs.deleteconfirmation.$el);
                }
                else {
                    this.$root.$el.removeChild(this.$refs.deleteconfirmation.$el)
                }
                this.$refs.deleteconfirmation.toggleModal();
            }
        },
        mounted: function() {

        }
    };
</script>
